import type { UpdateProfileBody } from "@nlc/shared-types";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { toast } from "@/components/toast/toast-queue";
import {
  profileKeys,
  projectsByOwnerKeys,
  projectUsersKeys,
  updateRolesKeys,
  usersKeys,
} from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useUpdateUserProfile(userId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateProfileBody) =>
      apiClient.url(`/users/${userId}`).put(data).res(),
    onError: () => {
      toast.add({
        description: "Failed to update profile",
        timeout: 3000,
        type: "error",
      });
    },
    onSuccess: (_, variables) => {
      toast.add({
        description: "Profile updated successfully",
        timeout: 3000,
        type: "success",
      });
      queryClient.invalidateQueries({ queryKey: profileKeys.userById(userId) });
      queryClient.invalidateQueries({ queryKey: usersKeys.all });
      queryClient.invalidateQueries({
        queryKey: updateRolesKeys.byTargetUserId(userId),
      });
      queryClient.invalidateQueries({
        queryKey: projectsByOwnerKeys.byUserId(userId),
      });
      if ("customerSuccessId" in variables) {
        queryClient.invalidateQueries({ queryKey: projectUsersKeys.all });
      }
    },
  });
}
